export const SET_TYPES_LIST = 'SET_TYPES_LIST'
